// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_VincularComboResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/vincular_combo/{item_id}
 *
 * O item coberto, a reserva gravada no razao e o saldo da compra DEPOIS dela
 * (pares, derivados do razao so_combo_movements).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_VincularComboResponseDados {
item_id: number
combo_purchase_id: number
movement_id: number
quantidade: number
reservado: number
consumido: number
disponivel: number
}

export type Orders_VincularComboResponse = ApiResponse<Orders_VincularComboResponseDados>;

registerResponseContract('Orders_VincularComboResponse', {
  item_id:           { type: 'number',  required: true },
  combo_purchase_id: { type: 'number',  required: true },
  movement_id:       { type: 'number',  required: true },
  quantidade:        { type: 'number',  required: true },
  reservado:         { type: 'number',  required: true },
  consumido:         { type: 'number',  required: true },
  disponivel:        { type: 'number',  required: true },
})
